// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"jz_a bhj_qr bhj_a bhj_w","BlogsPopularFeed__loading":"jz_b"};